import * as constants from "./constants";
import ProductTemplate from "../../template";
import { routesFlat } from '@routes'
import { beTagsFlat } from '@helpers/constants'

export default function TreeLevel() {
    const props = {
        constants,
        exploreData: routesFlat.products,
        product: beTagsFlat.treeLevel
    };
    return <ProductTemplate {...props} />;
}
